/* global treeUrl treeUpdateUrl subTreeUrl unassignedUrl subUnassignedUrl organigramType costcenters organigramEventId organigramFilterPreference organigramContext */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import WorkforceOrganigram from './WorkforceOrganigram';

export default function WorkforceOrganigramIndex(props) {
    return (
        <div className="tw-h-full tw-px-6 tw-py-6.5 tw-rounded-lg tw-shadow-primary">
            <WorkforceOrganigram
                type={props.type}
                fetchUrl={props.fetchUrl}
                treeUpdateUrl={props.treeUpdateUrl}
                subFetchUrl={props.subFetchUrl}
                unassignedUrl={props.unassignedUrl}
                subUnassignedUrl={props.subUnassignedUrl}
                costcenters={props.costcenters}
                eventId={props.eventId}
                filterPreference={props.filterPreference}
                exportContext={props.exportContext}
            />
        </div>
    );
}

if (document.getElementById('WorkforceOrganigram')) {
    var rootEl = document.getElementById('WorkforceOrganigram');
    ReactDOM.render(
        // <WorkforceOrganigramIndex fetchUrl={treeUrl} subFetchUrl={subTreeUrl || ''} type={organigramType} costcenters={costcenters || '[]'} />, //
        // rootEl,
        <App>
            <WorkforceOrganigramIndex
                fetchUrl={treeUrl}
                treeUpdateUrl={treeUpdateUrl}
                subFetchUrl={subTreeUrl || ''}
                unassignedUrl={typeof unassignedUrl !== 'undefined' ? unassignedUrl : ''}
                subUnassignedUrl={typeof subUnassignedUrl !== 'undefined' ? subUnassignedUrl : ''}
                type={organigramType}
                costcenters={costcenters || '[]'}
                eventId={typeof organigramEventId !== 'undefined' ? organigramEventId : null}
                filterPreference={typeof organigramFilterPreference !== 'undefined' ? organigramFilterPreference : {}}
                exportContext={typeof organigramContext !== 'undefined' ? organigramContext : {}}
            />
        </App>,
        rootEl,
    );
}
